import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'

export const useBookingTypeIconBadgeStyles = makeStyles(() => ({
  iconBadge: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg, & .MuiSvgIcon-root': {
      width: 14,
      height: 14,
      fontSize: 14,
    },
  },
  chipLessonPack: {
    backgroundColor: '#D2DEE3',
    color: '#172024',
  },
  chipAccessCode: {
    backgroundColor: '#F1E9D8',
    color: '#5C4922',
  },
  chipPrivate: {
    backgroundColor: '#CCDDFF',
    color: '#001C57',
  },
  chipGiftable: {
    backgroundColor: '#CCDDFF',
    color: '#001C57',
  },
}))

const VARIANT_CLASS = {
  private: 'chipPrivate',
  accessCode: 'chipAccessCode',
  lessonPack: 'chipLessonPack',
  giftable: 'chipGiftable',
}

const BookingTypeIconBadge = ({ label, variant, className, children }) => {
  const classes = useBookingTypeIconBadgeStyles()
  const variantClass = variant ? classes[VARIANT_CLASS[variant]] : null

  return (
    <Tooltip title={label}>
      <Box
        component="span"
        className={clsx(classes.iconBadge, variantClass, className)}
        aria-label={label}
        role="img"
      >
        {children}
      </Box>
    </Tooltip>
  )
}

BookingTypeIconBadge.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['private', 'accessCode', 'lessonPack', 'giftable']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

BookingTypeIconBadge.defaultProps = {
  variant: undefined,
  className: undefined,
}

export default BookingTypeIconBadge
